import React from 'react';
import styles from './AdGoogleScore.module.scss';
import ThumbsUpDownRoundedIcon from '@material-ui/icons/ThumbsUpDownRounded';
import LinkBlock from 'gui/components/linkBlock';
import GenericDetail
  from 'gui/components/listPage/components/ad/components/genericDetail';
import {IPlaceDetails} from "data/interfaces/products";

interface IAdGoogleScore {
  placeDetails: IPlaceDetails | IPlaceDetails[];
}

const AdGoogleScore = (props: IAdGoogleScore) => {
  const placeDetails: any = (Array.isArray(props.placeDetails) && props.placeDetails[0]) || props.placeDetails;
  return (placeDetails && placeDetails.rating) ? (
    <GenericDetail
      title={<span className={styles.title}>
  ציון הביקורת(מאת <LinkBlock style={{display: 'inline', padding: 0, margin: 0}}
                              href={placeDetails.url}>Google</LinkBlock>)
    </span>}
      icon={ThumbsUpDownRoundedIcon}
    >
      {placeDetails.rating}
    </GenericDetail>
  ) : null;
};

AdGoogleScore.defaultProps = {};
export default AdGoogleScore;
